$(function () {
  const supports = {
    init() {
      supports.create();
    },
    create() {
      $(document).on('click', '[data-cta-supports]', function() {
        const self = $(this);
        const type = self.data('cta-supports');
        const target = $(self.data('target'));

        $('[data-cta-supports]').removeClass('no-active').removeClass('active');
        if (target && target.length && type) {
          $('[data-cta-supports]').addClass('no-active');
          self.removeClass('no-active');
          self.addClass('active');

          if (type === 'helpful-links') {
            target.find('[data-toggle-display="open"]').trigger('click');
          }

          if (type === 'share') {
            target.stop().fadeIn();
            target.addClass('opened');
            $('[data-overlay]').stop().fadeIn();
          }

          if (type === 'talk') {
            target.trigger('click');
          }
        }
      });

      $(document).mouseup(function (e) {
        const container = $("[data-share]");

        if (
          !container.is(e.target) &&
          container.has(e.target).length === 0 &&
          container.hasClass("opened")
        ) {
          container.removeClass("opened");
          container.stop().fadeOut();
          $('[data-overlay]').stop().fadeOut();
          $('[data-cta-supports]').removeClass('active').removeClass('no-active');
        }
      });
      
      $('[data-popup-close][data-name="longform_shortform"]').on('click', function() {
        $('[data-cta-supports]').removeClass('active').removeClass('no-active');
      });
    },
  };

  supports.init();
});
